export enum AvailableLocaleCodes {
  // enUS = 'en-US',
  ruRU = 'ru-RU'
}
